module.exports = __webpack_public_path__ + "img/globe-color.6170730.svg";